import { css } from "@emotion/css"

import NumberField from "@p-ban/common/src/components/form/NumberField/NumberField"
import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"
import useDebounce from "@p-ban/common/src/hooks/useDebounce"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisabledCondition from "../../../../../service/getDisabledCondition"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import FieldSet from "../../../../components/1Click/FieldSet"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import DisabledOverlay from "../../../../components/1Click/overlay/DisabledOverlay"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./dipPartCnt.png"

const 挿入部品 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const condition = getDisplayCondition(values)
  const disabled = getDisabledCondition(values)
  const shouldShow = condition.dipPartCnt || condition.sideOfDip

  const onUpdateValue = useDebounce(handlers.number)

  return (
    <OneClickField isShow={shouldShow} legend="挿入部品" helpURL={HELP_LINKS.挿入部品} src={img} mapChildren>
      <>
        <label>
          <span className={style}>挿入部品（DIP）</span>
          <NumberField
            name={FIELD_NAMES.挿入部品}
            value={values.dipPartCnt}
            onUpdateValue={onUpdateValue}
            min={0}
            max={9999}
            maxDecimalDigits={0}
            step={1}
            suffix="点／枚"
            error={!!errors?.dipPartCnt}
          />
        </label>
        <OneClickFieldMessages error={errors?.dipPartCnt} />
      </>
      <>
        <FieldSet legend="実装面">
          <RadioGroup
            name={FIELD_NAMES["実装面 DIP"]}
            selectedValue={values.sideOfDip}
            onChange={handlers.radio}
            disabled={disabled.sideOfDip}
          >
            <OneClickFieldStack>
              <Radio value={ESTIMATE_CONSTANT["実装面 DIP"].部品面.value}>部品面</Radio>
              <Radio value={ESTIMATE_CONSTANT["実装面 DIP"].半田面.value}>半田面</Radio>
              <Radio value={ESTIMATE_CONSTANT["実装面 SMD"].両面.value}>両面</Radio>
            </OneClickFieldStack>
          </RadioGroup>
        </FieldSet>
        <OneClickFieldMessages error={errors?.sideOfDip} />
        {disabled.sideOfDip && <DisabledOverlay />}
      </>
    </OneClickField>
  )
}

export default 挿入部品

const style = css`
  display: block;
  padding-bottom: 8px;
  font-size: 13px;
  line-height: 14px;
`
